import { SettingData } from '../dto/EntityRepository';
import { MemberType } from '../enum/EnumRepository';
import type { PageType } from './currentPage';
import { isExposureLevelAccessible } from './exposureLevel';

const FALLBACK_PAGES = [
  'projects',
  'works',
  'texts',
  'members',
  'about',
  'contact',
] as const;

export const isArchivePageVisible = (
  setting: SettingData,
  page: string,
): boolean => {
  const menu = page === 'projectDetail' ? 'projects' : page;

  if (menu === 'members') {
    return (
      setting.memberType === MemberType.GROUP &&
      setting.menuVisible.members !== false
    );
  }

  return setting.menuVisible[
    menu as keyof SettingData['menuVisible']
  ] === true;
};

export const getArchiveEntryPath = (
  setting: SettingData,
  handle: string,
  includeBillboard: boolean,
): string | null => {
  if (includeBillboard && isArchivePageVisible(setting, 'billboard')) {
    return `/@${handle}/`;
  }

  const fallbackPage = FALLBACK_PAGES.find((page) =>
    isArchivePageVisible(setting, page),
  );

  return fallbackPage ? `/@${handle}/${fallbackPage}` : null;
};

export type ArchiveAccessDecision =
  | { type: 'allow' }
  | { type: 'deny' }
  | { type: 'redirect'; path: string }
  | { type: 'empty' };

export const resolveArchiveAccess = (
  setting: SettingData,
  page: PageType,
  handle: string,
  isOwner: boolean,
): ArchiveAccessDecision => {
  if (page === 'members' && setting.memberType !== MemberType.GROUP) {
    return { type: 'deny' };
  }

  if (isOwner) {
    return { type: 'allow' };
  }

  if (!isExposureLevelAccessible(setting.exposureLevel)) {
    return { type: 'deny' };
  }

  if (isArchivePageVisible(setting, page)) {
    return { type: 'allow' };
  }

  if (page !== 'billboard') {
    return { type: 'deny' };
  }

  const fallbackPath = getArchiveEntryPath(setting, handle, false);
  return fallbackPath
    ? { type: 'redirect', path: fallbackPath }
    : { type: 'empty' };
};
